import { filterOutHiddenModules } from 'layout/utils-show-hide.js';
import { IPrimarySlotPropsMap, ISecondarySlotPropsMap } from 'redux-state/layout/types.layout.js';
import { IColumnLayout, IModuleConfig, ISlotConfig } from 'redux-state/layout/types.modules.js';

const createDummyISlotConfig = (modules: IModuleConfig[] = []): ISlotConfig => {
  return {
    modules,
  };
};

export const filterPrimaryConfig = (content: IPrimarySlotPropsMap, layout: IColumnLayout): IPrimarySlotPropsMap => ({
  first: createDummyISlotConfig(filterOutHiddenModules(layout, content.first.modules)),
  leftMajor: createDummyISlotConfig(filterOutHiddenModules(layout, content.leftMajor.modules)),
  leftMinor: createDummyISlotConfig(filterOutHiddenModules(layout, content.leftMinor.modules)),
  main: createDummyISlotConfig(filterOutHiddenModules(layout, content.main.modules)),
  rightMajor: createDummyISlotConfig(filterOutHiddenModules(layout, content.rightMajor.modules)),
  rightMinor: createDummyISlotConfig(filterOutHiddenModules(layout, content.rightMinor.modules)),
});

export const filterSecondaryConfig = (
  secondaryContent: ISecondarySlotPropsMap,
  layout: IColumnLayout,
): ISecondarySlotPropsMap => ({
  major: createDummyISlotConfig(filterOutHiddenModules(layout, secondaryContent.major.modules)),
  minor: createDummyISlotConfig(filterOutHiddenModules(layout, secondaryContent.minor.modules)),
  right: createDummyISlotConfig(filterOutHiddenModules(layout, secondaryContent.right.modules)),
});
